
import {Link} from "react-router-dom";

import './Alert.scss';

const Alert = (props) => {

    const icon = props && props.icon ? props.icon : null
    const styles = props && props.styles ? props.styles : {}
    const message = props && props.message ? props.message : null
    const baseClassName = 'alert alert-outline d-flex align-items-center'
    const className = props && props.className ? baseClassName + ' ' + props.className : baseClassName + ' alert-warning'

    return (
        <div className="Alert">
            <div className={className} role="alert" style={styles}>
                {icon}
                <div className="alert-text">
                    {message}
                    {props && props.docs && props.docs.message && props.docs.message}
                    {props && props.docs && props.docs.path && <Link to={props.docs.path}>check the documentation</Link>}
                </div>
            </div>
        </div>
    )
}

export default Alert;